module.exports = __webpack_public_path__ + "static/media/loader.dde0ed76.gif";